import parseVoizMonthDate from './parse-voiz-month-date.js';

/**
 * Voiz stores the aggregation month information in `YYYY-M` or `YYYY-MM` format.
 * The format depends on the month.
 *  - If the month between January and September then uses 1 digit for month. `2022-1` for January
 *  - If the month between October and December then uses 2 digit for month. `2022-10` for October
 *  Chrome new Date(date) parses both (1 and 2 digit) format correctly, but Safari parses only the 2 digit format.
 *  This helper function will convert the voiz date to moment date string.
 *
 * @param {string} date - voiz month date
 * @param {string} format - moment date format
 * @returns {string} - formated date in Hungarian local
 */
export default function formatVoizMonth(date, format) {
  return parseVoizMonthDate(date).format(format);
}
